import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withLocalize } from 'react-localize-redux';
import Toggle from 'react-toggle';
import Label from '../../components/foundations/Label';
import { getTranslatedItemType, MEMBER_TYPES, translationPrefix as translationRootPrefix } from '../utils';
import 'react-toggle/style.css';
import css from './AddFutureItems.css';

const translationPrefix = `${translationRootPrefix}.AUTO_ADD_FUTURE_ITEMS`;
const TITLE_TRANSLATION_KEYS = {
    [MEMBER_TYPES.AGENCY]: {
        appsites: 'APPSITES_AGENCIES',
    },
};
const DESCRIPTION_TRANSLATION_KEYS = {
    [MEMBER_TYPES.AGENCY]: {
        appsites: 'APPSITES_AGENCIES',
        source: 'SOURCES_AGENCIES',
        sdk_event: 'SDK_EVENTS_AGENCIES',
    },
};

const AddFutureItems = ({
    translate,
    activeMemberType = '',
    itemType = '',
    itemTypeData = {},
    addFuture = false,
    onChange = () => {},
    className = '',
}) => {
    const descriptionTranslationKey = DESCRIPTION_TRANSLATION_KEYS[activeMemberType]?.[itemType];
    const titleTranslationKey = TITLE_TRANSLATION_KEYS[activeMemberType]?.[itemType] || 'GENERAL';
    const translatedItemType = getTranslatedItemType(translate, itemType, itemTypeData);

    return (
        <div className={classNames(css.container, className)}>
            <Toggle
                icons={false}
                checked={addFuture}
                onChange={e => onChange(e.target.checked)}
                className={css.toggle}
            />
            <div className={css.labelContainer}>
                <Label
                    type="sideLabel"
                    className={css.title}
                    text={`${translationPrefix}.TITLE.${titleTranslationKey}`}
                    textReplace={{
                        itemType: translatedItemType,
                    }}
                />
                {descriptionTranslationKey && (
                    <Label type="p" text={`${translationPrefix}.DESCRIPTION.${descriptionTranslationKey}`} />
                )}
            </div>
        </div>
    );
};

AddFutureItems.propTypes = {
    translate: PropTypes.func,
    activeMemberType: PropTypes.string,
    itemType: PropTypes.string,
    itemTypeData: PropTypes.object,
    addFuture: PropTypes.bool,
    onChange: PropTypes.func,
    className: PropTypes.string,
};

export default withLocalize(AddFutureItems);
